import { createUniqueId, onCleanup, useContext } from 'solid-js';
import { twMerge } from '@troon/tailwind-preset/merge';
import { DescriptionContext } from './field';
import type { ParentProps } from 'solid-js';

export function FieldDescription(props: ParentProps<{ class?: string }>) {
	const { add, remove } = useContext(DescriptionContext);
	const id = createUniqueId();

	add({ id });

	onCleanup(() => {
		remove({ id });
	});

	return (
		<div id={id} class={twMerge('text-start text-sm text-neutral-800', props.class)}>
			{props.children}
		</div>
	);
}
